<template>
  <vue-aos animation-class="slide-in animated" :threshold="0">
    <section class="about mt-4" id="about">
      <div class="container">
        <div class="row d-flex flex-column-reverse flex-md-row">
          <div class="col-md-6 col-12">
            <div class="py-3 d-flex flex-column justify-content-center h-100">
              <h3 class="underline text-portfolio4 letter-spacing-md">
                About Us
              </h3>
              <p class="letter-spacing-sm">
                Robust Office is a UAE-PAKISTAN based team of Web Developers
                with years of exprience in this field. Since we are already
                providing services in freelance market places , we decided to go
                for working with clients outside of these platforms. You can
                hire us for any kind of website, for example : E-commerce ,
                School Management System , Medical & Pharmacy Management Systems
                , Business Portfolio websites and many more. Feel free to
                discuss your project with us.
              </p>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <img class="img-fluid" v-lazy="aboutImg" alt srcset />
          </div>
        </div>
      </div>
    </section>
  </vue-aos>
</template>

<script>
export default {
  data() {
    return {
      aboutImg: require("../../assets/images/about/about3.png"),
    };
  },
};
</script>

<style></style>
